import { MutableRefObject, useEffect } from "react";

type RefType = MutableRefObject<any> | MutableRefObject<any>[];

export const useOutsideClick = (refs: RefType, callback: () => void) => {
  const handleClick = (e: MouseEvent) => {
    const refArray = Array.isArray(refs) ? refs : [refs];
    const isOutside = refArray.every(
      (ref) => ref.current && !ref.current.contains(e.target)
    );
    if (isOutside) {
      callback();
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  });
};
